import { render, staticRenderFns } from "./AddNewPartner.vue?vue&type=template&id=21e8031d&scoped=true"
import script from "./AddNewPartner.vue?vue&type=script&lang=js"
export * from "./AddNewPartner.vue?vue&type=script&lang=js"
import style0 from "./AddNewPartner.vue?vue&type=style&index=0&id=21e8031d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21e8031d",
  null
  
)

export default component.exports